import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchCardsList, fetchCardDetails, createCardWithLink, createEmployeeCard } from "./cardThunks";
import { CardDetails, CardSummary } from "./cards";

interface CardsState {
  list: CardSummary[];
  details: Record<string, CardDetails>;
  loadingList: boolean;
  loadingCard: boolean;
  creatingCard: boolean;
  activeCardId: string | null;
  error: string | null;
}

const initialState: CardsState = {
  list: [],
  details: {},
  loadingList: false,
  loadingCard: false,
  creatingCard: false,
  activeCardId: null,
  error: null,
};

const cardsSlice = createSlice({
  name: "cards",
  initialState,
  reducers: {
    setActiveCardId: (state, action: PayloadAction<string>) => {
      state.activeCardId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // ---- Fetch list ----
      .addCase(fetchCardsList.pending, (state) => {
        state.loadingList = true;
        state.error = null;
      })
      .addCase(fetchCardsList.fulfilled, (state, action) => {
        state.loadingList = false;
        state.list = action.payload;
        // Set first card as active by default
        if (action.payload.length && !state.activeCardId) {
          state.activeCardId = action.payload[0]._id;
        }
      })
      .addCase(fetchCardsList.rejected, (state, action) => {
        state.loadingList = false;
        state.error = action.payload as string;
      })

      // ---- Fetch single card ----
      .addCase(fetchCardDetails.pending, (state) => {
        state.loadingCard = true;
      })
      .addCase(fetchCardDetails.fulfilled, (state, action) => {
        state.loadingCard = false;
        // state.details = {};
        state.details[action.payload._id] = action.payload;
      })
      .addCase(fetchCardDetails.rejected, (state, action) => {
        state.loadingCard = false;
        state.error = action.payload as string;
      })

      // ---- Create card with link ----
      .addCase(createCardWithLink.pending, (state) => {
        state.creatingCard = true;
      })
      .addCase(createCardWithLink.fulfilled, (state, action) => {
        state.creatingCard = false;
        state.list.push(action.payload.card);
      })
      .addCase(createCardWithLink.rejected, (state, action) => {
        state.creatingCard = false;
        state.error = action.payload as string;
      })

      // ---- Create employee card ----
      .addCase(createEmployeeCard.pending, (state) => {
        state.creatingCard = true;
      })
      .addCase(createEmployeeCard.fulfilled, (state, action) => {
        state.creatingCard = false;
        state.list.push(action.payload.card);
      })
      .addCase(createEmployeeCard.rejected, (state, action) => {
        state.creatingCard = false;
        state.error = action.payload as string;
      });
  },
});

export const { setActiveCardId } = cardsSlice.actions;
export default cardsSlice.reducer;
